import { inject, injectable } from 'inversify';
import { backendUrl } from 'src/config';
import {
  CompanyDataSourceInterface,
  GetCompanyResponse,
  GetCurrentUserCompanyParams,
} from 'src/features/companies/data/CompanyDataSource.types';
import HttpClient from 'src/features/http';

@injectable()
class CompanyDataSource implements CompanyDataSourceInterface {
  @inject(HttpClient) private httpClient!: HttpClient;

  async getCurrentUserCompany(
    params: GetCurrentUserCompanyParams
  ): Promise<GetCompanyResponse> {
    const response = await this.httpClient
      .getClient()
      .get<GetCompanyResponse>(`/company`, {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${params.accessToken}`,
        },
      });

    return response.data;
  }
}

export default CompanyDataSource;
